import { createContext } from 'react';
export default /*#__PURE__*/createContext({
  modal: function modal() {
    return null;
  },
  showModal: function showModal() {},
  dismissModal: function dismissModal() {}
});